import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

const STATUS_KEYS = {
  paperEnd: {
    title: 'kiosk.outOfPaperTitle',
    message: 'kiosk.outOfPaperMessage',
  },
  nearEnd: {
    title: 'kiosk.paperLowTitle',
    message: 'kiosk.paperLowMessage',
  },
  unknown: {
    title: 'kiosk.printerOfflineTitle',
    message: 'kiosk.printerOfflineMessage',
  },
};

function ModalPaperOutKiosk() {
  const { t } = useTranslation();

  const { showModalPaperOutKiosk, updateShowModalPaperOutKiosk } =
    useContext(AppContext);

  const keys = STATUS_KEYS[showModalPaperOutKiosk] ?? STATUS_KEYS.paperEnd;

  return (
    <>
      <div id="react-confirm-alert">
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(3,6,18,0.88)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px',
          }}
        >
          <div
            style={{
              width: 'min(760px, 96vw)',
              borderRadius: '24px',
              overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.12)',
              boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
              backdropFilter: 'blur(14px)',
              WebkitBackdropFilter: 'blur(14px)',
              background:
                'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
              padding: '40px 48px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Typography
              sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}
            >
              {t(keys.title)}
            </Typography>
            <Typography
              sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '24px' }}
            >
              {t(keys.message)}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}></Box>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalPaperOutKiosk;
